import React, { MouseEventHandler } from "react";
import Modal from "react-modal";
import { useTranslation } from "react-i18next";

interface AdultWarningModalProperties {
    readonly onConfirmAdultContent: () => void;
    readonly onAfterClose?: () => void;
}

export default function AdultWarningModal({ onConfirmAdultContent, onAfterClose }: AdultWarningModalProperties): React.JSX.Element {
    const { t } = useTranslation("general");
    const [modalIsOpen, setModalIsOpen] = React.useState(true);

    const confirmAdultContent: MouseEventHandler<HTMLAnchorElement> = (event): void => {
        event.preventDefault();
        onConfirmAdultContent();
        setModalIsOpen(false);
    };

    return (
        <Modal
            isOpen={modalIsOpen}
            className="modal-dialog modal-transition"
            overlayClassName="react-modal-backdrop react-modal-backdrop-opaque"
            closeTimeoutMS={150}
            onAfterClose={onAfterClose}
        >
            <div className="modal-content">
                <div className="modal-header empty modal-header-image">
                </div>
                <div className="modal-body">
                    <div className="well well-transparent">
                        <div className="product-row">
                            <p className="fakeh3">{t("adultsOnly")}</p>
                            <div className="bylo-inner">
                                <div className="bylo-inner-left">
                                    <img src="/css/image/karel18.png" alt="" />
                                </div>
                                <div className="bylo-inner-right">
                                    <p>{t("adultsOnlyMessage")}</p>
                                    <div className="shop-button">
                                        <a href="/" className="btn btn-success">{t("leave")}</a>
                                        <a href="#" className="btn btn-danger" onClick={confirmAdultContent}>{t("continue")}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
